module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/list-8195ee6bc64ab791c6661581e3c16dd7.svg";